import React, { useState } from "react";
import { Trans } from "react-i18next";
import Boost from "../main/Boost";
import { NavLink } from "react-router-dom";
import SideNav from "react-simple-sidenav";
import SideBar from "../main/SideBar";

const Header = ({name}) => {
  const [showNav3, setShowNav3] = useState(false);
  return (
    <>
     <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
               <div class="heading-left-top d-flex">
                  <div className="align-self-center ">
                      <div className="iconHolder align-self-center mr-1">
                          <div className="backGlow  d-block d-lg-none">
                              <div className="sideBarToggler sidebarIcoPos" onClick={() => setShowNav3(true)}></div>
                          </div>
                      </div>
                  </div>
                  <span class="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Match Friends">Match Friends</Trans></span>    
               </div>
               <div className="backGlow white-bg"></div>
            </div>
      <div className="sidebarResp d-block d-lg-none">
        <SideNav
          showNav={showNav3}
          onHideNav={() => setShowNav3(false)}
          title={<div></div>}
          items={[<SideBar />]}
        />
      </div>
    </>
  );
};

export default Header;
